export const fileNameGenerater = (extension: string): string => {
    const date = new Date();
    return `${date.toLocaleDateString()}-${date.getTime()}.${extension}`;
};

export const fileNameGeneraterWithoutType = (moduleName: string, extension: string): string => {
    const date = new Date();
    return `${moduleName}-${date.toLocaleDateString()}-${date.getTime()}.${extension}`;
};

export const dynamicFileNameGenerater = (moduleName: string, extension: string, type: string | undefined): string => {
    const date = new Date();
    return `${moduleName}-${type}-${date.toLocaleDateString()}-${date.getTime()}.${extension}`;
};